import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";

export default function CreatorsList() {
    const [creators, setCreators] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        api.get("/creators")
            .then((r) => setCreators(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-white text-slate-900" data-testid="creators-list">
            <Navbar />
            <section className="border-b hairline">
                <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-12">
                    <div className="chip chip-lime inline-flex mb-3">CREATORS</div>
                    <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
                        Meet the creators
                    </h1>
                    <p className="text-sm text-slate-500 mt-2 max-w-xl">
                        Browse profiles and commission custom videos directly.
                    </p>
                </div>
            </section>

            <section className="max-w-[1280px] mx-auto px-5 lg:px-8 py-10">
                {loading ? (
                    <div className="text-slate-500 overline">Loading…</div>
                ) : creators.length === 0 ? (
                    <div className="card-ecom p-12 text-center text-slate-500">
                        No creators yet.
                    </div>
                ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
                        {creators.map((c) => (
                            <Link
                                key={c.id}
                                to={`/creators/${c.id}`}
                                className="card-ecom p-6 flex flex-col items-center text-center"
                                data-testid={`creator-tile-${c.id}`}
                            >
                                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-coral to-lime flex items-center justify-center text-white font-display font-bold text-3xl mb-4">
                                    {c.name?.[0]?.toUpperCase()}
                                </div>
                                <div className="font-display text-lg font-semibold">{c.name}</div>
                                <div className="text-xs text-slate-500 mt-1">
                                    {c.video_count} videos
                                </div>
                                <div className="chip chip-coral mt-4">View profile →</div>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
